import { Component, OnInit, Renderer2, HostListener } from '@angular/core';
import { AuthBaseComponent } from '../auth-base/auth-base.component';
import { AuthenticationResult } from '../models/authentication.model';
import { AuthenticationStatus } from '../enums/enums';
import { ModalService } from 'hsg';
import { AuthUserService } from '../auth-user.service';
import { NgForm } from '../../../../node_modules/@angular/forms';
import { AuthIssueDateComponent } from '../auth-issue-date/auth-issue-date.component';
import { ServerResponse } from '../constants/server-response.model';
@Component({
  selector: 'app-auth-credit-card',
  templateUrl: './auth-credit-card.component.html',
  styleUrls: ['./auth-credit-card.component.css']
})
export class AuthCreditCardComponent extends AuthBaseComponent implements OnInit {
  constructor(private renderer: Renderer2, protected modalService:ModalService, protected authService:AuthUserService) {
    super(modalService,authService);
  }
  public isValidDate: boolean;
  public date = { day: '', month: '', year: '' };
  public data: any = {};
  
  elasticLogit(){
    this.authUserService.sendAuthData("ElasticLogger", { elasticCode: '2165' })
    .subscribe(res => console.log("sent elasticLog code:2165 - open window", res), error =>console.log("sent elasticLog - open window error!",error));
  }
  ngOnInit() {
    this.elasticLogit();
    sessionStorage.setItem("currentWindow","אימות פרטי כרטיס אשראי");
    sessionStorage.setItem("elasticCode", "2192");
    this.data = this.modalService.data;
    this.isShowContactLink = this.shouldContactLink('authCreditCard');
    const element = this.renderer.selectRootElement('#cardnumber');
    setTimeout(() => element.focus(), 0);
  }
  submit(form:NgForm) {
    const element =  this.inputsQuery.map(elm => elm.elementRef.nativeElement).find(elm => elm.classList.contains('ng-invalid'));
    if(element){
      element.setAttribute('aria-invalid', true);
      setTimeout(() => element.focus(), 0);
    }
    form.value.cardnumber.replace(' ','');
    if (form.valid && this.isValidDate) {
      this.pending = true;
      this.serverError = null;
      
      const card = {
        creditCardDetails: {
          CardNum: form.value.cardnumber.trim(),
          Month: form.value.month,
          Year:form.value.year,
          CVV: form.value.cvv
        }
      };
      //console.log("sent parametes", card);
      this.authUserService.sendAuthData("ValidateCreditCard", card)
        .subscribe((res: AuthenticationResult) => {
          if (res.Status == AuthenticationStatus.Failure && res.Details.UserInputError == "InvalidCreditCard") {
            this.elasticLogit();
            this.serverError = "פרטי כרטיס האשראי שהקלדת אינם תקינים או אינם תואמים את פרטיך. יש להזין פרטי כרטיס הרשום על שמך ולוודא שהם תואמים את הכתוב על הכרטיס."
          }
          else if (res.Status == AuthenticationStatus.Failure && res.Details.UserInputError == "InvalidCreditCardTech") {
            this.elasticLogit();
            this.serverError = "אירעה תקלה באימות פרטי כרטיס האשראי שלך. אנו מטפלים בתקלה. יש לנסות שוב במועד מאוחר יותר."
          }
          else {
            if (res.Status == AuthenticationStatus.Success && res.Details.ProcessSuccess != ServerResponse.NEED_DETAILS) {
              res.Details.ProcessSuccess = ServerResponse.ISSUE_DATE;
            }
            this.modalService.close(res.Details);
          }
        },() => this.pending = false,
          () => this.pending = false
        )
    }
    this.buildFormAccessibility();
  }
  validateDate() {
    this.isValidDate =  new Date().getMonth() + 1 <= parseInt(this.date.month) &&
    new Date().getFullYear() == parseInt(`20${this.date.year}`) ||  new Date().getFullYear() < parseInt(`20${this.date.year}`)
  }
}
